import * as React from 'react';
import classNames from 'classnames';
import * as Classes from '../common/classes';
import { Checkbox } from './Checkbox';

type Props = Omit<
  React.ComponentProps<typeof Checkbox>,
  | 'tagName'
  | 'label'
  | 'defaultChecked'
  | 'large'
  | 'labelElement'
  | 'onClick'
  | 'alignIndicator'
  | 'defaultIndeterminate'
  | 'children'
  | 'inline'
> & {
  noButtonStyle?: boolean;
};

export const CheckboxButton: React.FC<Props> = ({
  className,
  noButtonStyle,
  disabled,
  onChange,
  ...other
}) => {
  let cls = classNames(className, Classes.CHECKBOX_BUTTON, {
    [Classes.CHECKBOX_BUTTON_NO_BUTTON]: noButtonStyle,
    [Classes.CHECKBOX_BUTTON_DISABLED]: disabled,
  });

  return (
    <div
      className={cls}
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
        !disabled &&
          onChange?.({
            target: {
              // @ts-ignore
              checked: !other.checked,
            },
            shiftKey: e?.shiftKey,
            ctrlKey: e?.ctrlKey,
            altKey: e?.altKey,
            clientX: e?.clientX,
            clientY: e?.clientY,
            metaKey: e?.metaKey,
          });
      }}
    >
      <Checkbox {...other} disabled={disabled} />
    </div>
  );
};
